module.exports = {
    PANEL_EXPANDED_EMIT_EVENT: 'deliverySaver:panelExpanded',
    PANEL_EXPANDED_BROADCAST_EVENT: 'deliverySaver:panelExpandedBroadcast',
    PANEL_EXPAND: 'deliverySaver:expand',
    SUBSCRIPTION_STATUS: {
        ACTIVE: 'Active',
        SUSPENDED: 'Suspended',
        CANCELLED: 'Cancelled',
    },
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver.constants.js